import { useSearchParams } from 'react-router';
import { useSession } from '../../session';
import { ExportWizard } from './ExportWizard';
import { ImportWizard } from './ImportWizard';
import './imports.css';

/**
 * Import und Export (KON-171): Startseite mit zwei Wegen, „Import“ und „Export“. Jeder startet einen geführten Ablauf mit Schritten und Hinweisen. Der gewählte Weg steht in der
 * Adresse (?modus=import), so führt ein Neuladen nicht zurück an den Anfang.
 */
export function ImportExportPage() {
  const { can } = useSession();
  const [params, setParams] = useSearchParams();
  const mode = params.get('modus');
  const open = (next: 'import' | 'export' | null) => setParams(next ? { modus: next } : {}, { replace: false });
  const mayImport = can('imports.write');
  const mayExport = can('imports.export');

  return (
    <>
      <div className="page-head">
        <h1>Import und Export</h1>
        <span className="muted">Daten übernehmen und herausgeben</span>
      </div>

      {mode === 'import' && mayImport ? (
        <ImportWizard onClose={() => open(null)} />
      ) : mode === 'export' && mayExport ? (
        <ExportWizard onClose={() => open(null)} />
      ) : (
        <div className="imp-start">
          <button type="button" className="imp-start__card" disabled={!mayImport} onClick={() => open('import')}>
            <span className="imp-start__icon" aria-hidden="true">⬇</span>
            <strong>Import</strong>
            <span>Kontakte oder Produkte aus einer Tabelle übernehmen, zum Beispiel aus Excel oder einem alten Programm. Mit Prüfung vorab, angelegt wird erst nach Ihrer Bestätigung.</span>
            <span className="imp-start__go">{mayImport ? 'Import starten' : 'Dafür fehlt Ihrer Rolle das Recht zum Anlegen und Bearbeiten'}</span>
          </button>
          <button type="button" className="imp-start__card" disabled={!mayExport} onClick={() => open('export')}>
            <span className="imp-start__icon" aria-hidden="true">⬆</span>
            <strong>Export</strong>
            <span>Eine Kopie Ihrer Daten für Excel, den Steuerberater oder zur Sicherung: einzelne Bereiche als CSV oder alles als ZIP, auf Wunsch mit Dokumenten.</span>
            <span className="imp-start__go">{mayExport ? 'Export starten' : 'Dafür fehlt Ihrer Rolle das Recht „Daten exportieren“'}</span>
          </button>
        </div>
      )}
    </>
  );
}
